import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  body {
    font-family: 'Archivo', sans-serif;
  }
`
export default GlobalStyles
